import React from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Divider, message, Form, Upload, Icon, Button } from 'antd';
import PropTypes from 'prop-types';

import ErrorContainer from '../components/FormErrorContainer';

const FormItem = Form.Item;

@inject('dataStore')
@observer
class SubmitData extends React.Component {
  static propTypes = {
    dataStore: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    const files = [];
    this.state = {
      files,
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      this.setState(() => {
        if (!err && !!this.state.files) {
          this.props.dataStore
            .submit({
              ...values,
              files: this.state.files,
            })
            .then(() => {
              if (!this.props.dataStore.dataSubmitError) {
                message.success('Data submission successful, refresing the page...', 5);
                setTimeout(() => this.props.history.push('/submit-data'), 5000);
              }
            });
        } else {
          this.props.dataStore.datasetSubmitError = {
            type: 'missingFieldError',
            details: ['Please select files to upload'],
          };
        }
      });
    });
  };
  handleFilesChange = (_, fileList) => {
    this.setState({
      files: fileList,
    });

    return false;
  };

  render() {
    const { dataStore } = this.props;
    return (
      <div>
        <Row type="flex" justify="center">
          <Divider>Renew Data</Divider>
          <Col xs={24} sm={12} lg={12}>
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="files">
                    <Upload ame="files" multiple beforeUpload={this.handleFilesChange}>
                      <Button>
                        <Icon type="upload" /> Select the xlsx files
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
              <ErrorContainer error={dataStore.dataSubmitError} />
              <FormItem>
                <Button type="primary" htmlType="submit" loading={dataStore.loadingData}>
                  Submit New Data
                </Button>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

const SubmitDataForm = Form.create()(SubmitData);

export default SubmitDataForm;



// WEBPACK FOOTER //
// ./src/screens/SubmitData.js